// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__iEV0V","content":"styles_content__3AHv6"};